import {Api} from "./index";

export const getAllRules = async (token) => {
    return await Api.get(`bonus-rule`, {
        headers: {
            "Authorization": "Bearer " + token
        }
    })
}

export const getById = async (token, id) => {
    return await Api.get(`bonus-rule/${id}`, {
        headers: {
            "Authorization": "Bearer " + token
        }
    })
}

export const create = async (name, config, token) => {
    const {data} = await Api.post(`bonus-rule`, {
        "name": name,
        "config": config,
    }, {
        headers: {
            "Authorization": "Bearer " + token
        }
    })
    return data
}

export const update = async (id, name, config, token) => {
    const {data} = await Api.put(`bonus-rule/${id}`, {
        "name": name,
        "config": config,
    }, {
        headers: {
            "Authorization": "Bearer " + token
        }
    })
    return data
}

export const deleteById = async (token, id) => {
    return await Api.delete(`bonus-rule/${id}`, {
        headers: {
            "Authorization": "Bearer " + token
        }
    })
}
